import * as yup from "yup";

export const subCategorySchema = yup.object().shape({
  sub_category_name: yup.string().required("Sub Category Name is Required *"),
  expense_category: yup.string().required("Expense Category is Required *"),
  account_no: yup.string().required("Account No. is Required *"),
  category_status: yup.boolean(),
});

export const subCategoryInitialValues = {
  sub_category_name: "",
  expense_category: "",
  account_no: "",
  category_status: false,
};
